/** Existing step numbers stay stable so saved Classic drafts remain readable. */
export type QuickProductLine = 'basic' | 'custom';
export const STYLE_STEP = 7;
export const VISION_STEP = 8;
export const CUSTOM_REVIEW_STEP = 9;
export const CUSTOM_DONE_STEP = 10;
export function quickQuestionSteps(productLine?: QuickProductLine): number[] {
  return productLine === 'custom' ? [1, 2, STYLE_STEP, VISION_STEP, 5, CUSTOM_REVIEW_STEP] : [1, 2, STYLE_STEP, 3, 4, 5];
}
export function nextQuickStep(step: number, productLine?: QuickProductLine): number {
  if (step === 2) return STYLE_STEP;
  if (step === STYLE_STEP) return productLine === 'custom' ? VISION_STEP : 3;
  if (step === VISION_STEP) return 5;
  if (step === 5) return productLine === 'custom' ? CUSTOM_REVIEW_STEP : 6;
  if (step === CUSTOM_REVIEW_STEP) return CUSTOM_DONE_STEP;
  return step + 1;
}
export function previousQuickStep(step: number, productLine?: QuickProductLine): number {
  if (step === 6) return 5;
  if (step === CUSTOM_DONE_STEP) return CUSTOM_REVIEW_STEP;
  const steps = quickQuestionSteps(productLine);
  return steps[steps.indexOf(step) - 1] ?? 0;
}
export function quickAnsweredThrough(step: number): number {
  // Preserve the original Sales progress milestones, not the new UI step IDs.
  return step === STYLE_STEP || step === VISION_STEP ? 2 : step === CUSTOM_REVIEW_STEP ? 5 : step;
}
export function validInspirationLink(value?: string): boolean {
  if (!value?.trim()) return true;
  try { return ['http:', 'https:'].includes(new URL(value.trim()).protocol); } catch { return false; }
}
